export const TranslatableLanguagesMap = {
	"afr": { iso3:"afr", iso1: "af", flag: "za", name: "Afrikaans" },
	"ara": { iso3:"ara", iso1: "ar", flag: "ae", name: "Arabic" },
	"hye": { iso3:"hye", iso1: "hy", flag: "am", name: "Armenian" },
	"aze": { iso3:"aze", iso1: "az", flag: "az", name: "Azerbaijani" },
	"eus": { iso3:"eus", iso1: "eu", flag: "es", name: "Basque" },
	"bel": { iso3:"bel", iso1: "be", flag: "by", name: "Belarusian" },
	"ben": { iso3:"ben", iso1: "bn", flag: "bd", name: "Bengali" },
	"bul": { iso3:"bul", iso1: "bg", flag: "bg", name: "Bulgarian" },
	"cat": { iso3:"cat", iso1: "ca", flag: "es-ca", name: "Catalan" },
	"hrv": { iso3:"hrv", iso1: "hr", flag: "hr", name: "Croatian" },
	"ces": { iso3:"ces", iso1: "cs", flag: "cz", name: "Czech" },
	"dan": { iso3:"dan", iso1: "da", flag: "dk", name: "Danish" },
	"nld": { iso3:"nld", iso1: "nl", flag: "nl", name: "Dutch" },
	"eng": { iso3:"eng", iso1: "en", flag: "us", name: "English" },
	"est": { iso3:"est", iso1: "et", flag: "ee", name: "Estonian" },
	"fin": { iso3:"fin", iso1: "fi", flag: "fi", name: "Finnish" },
	"fra": { iso3:"fra", iso1: "fr", flag: "fr", name: "French" },
	"kat": { iso3:"kat", iso1: "ka", flag: "ge", name: "Georgian" },
	"deu": { iso3:"deu", iso1: "de", flag: "de", name: "German" },
	"ell": { iso3:"ell", iso1: "el", flag: "gr", name: "Greek" },
	"hau": { iso3:"hau", iso1: "ha", flag: "ng", name: "Hausa" },
	"heb": { iso3:"heb", iso1: "he", flag: "il", name: "Hebrew" },
	"hin": { iso3:"hin", iso1: "hi", flag: "in", name: "Hindi" },
	"hun": { iso3:"hun", iso1: "hu", flag: "hu", name: "Hungarian" },
	"isl": { iso3:"isl", iso1: "is", flag: "is", name: "Icelandic" },
	"ind": { iso3:"ind", iso1: "id", flag: "id", name: "Indonesian" },
	"ita": { iso3:"ita", iso1: "it", flag: "it", name: "Italian" },
	"jpn": { iso3:"jpn", iso1: "ja", flag: "jp", name: "Japanese" },
	"kaz": { iso3:"kaz", iso1: "kk", flag: "kz", name: "Kazakh" },
	"ckb": { iso3:"ckb", iso1: "ku", flag: "", name: "Kurdish" },
	"kor": { iso3:"kor", iso1: "ko", flag: "kr", name: "Korean" },
	"lit": { iso3:"lit", iso1: "lt", flag: "lt", name: "Lithuanian" },
	"mkd": { iso3:"mkd", iso1: "mk", flag: "mk", name: "Macedonian" },
	"cmn": { iso3:"cmn", iso1: "zh", flag: "cn", name: "Mandarin" },
	"mar": { iso3:"mar", iso1: "mr", flag: "in", name: "Marathi" },
	"nob": { iso3:"nob", iso1: "nn", flag: "no", name: "Norwegian" },
	"pes": { iso3:"pes", iso1: "fa", flag: "ir", name: "Persian" },
	"pol": { iso3:"pol", iso1: "pl", flag: "pl", name: "Polish" },
	"por": { iso3:"por", iso1: "pt", flag: "pt", name: "Portuguese" },
	"ron": { iso3:"ron", iso1: "ro", flag: "ro", name: "Romanian" },
	"run": { iso3:"run", iso1: "rn", flag: "bi", name: "Rundi" },
	"rus": { iso3:"rus", iso1: "ru", flag: "ru", name: "Russian" },
	"srp": { iso3:"srp", iso1: "sr", flag: "rs", name: "Serbian" },
	"slk": { iso3:"slk", iso1: "sk", flag: "sk", name: "Slovak" },
	"spa": { iso3:"spa", iso1: "es", flag: "es", name: "Spanish" },
	"swe": { iso3:"swe", iso1: "sv", flag: "se", name: "Swedish" },
	"tgl": { iso3:"tgl", iso1: "tl", flag: "ph", name: "Tagalog" },
	"tur": { iso3:"tur", iso1: "tk", flag: "tr", name: "Turkish" },
	"ukr": { iso3:"ukr", iso1: "uk", flag: "ua", name: "Ukrainian" },
	"vie": { iso3:"vie", iso1: "vi", flag: "vn", name: "Vietnamese" }
};
